import React, { useState } from "react"
import { Button, Col, Label, Modal, Row, Table } from "reactstrap"
import { Tbody, Thead } from "react-super-responsive-table"
import ValidationForm from "./ValidationForm"

export const normalizeValidations = raw => {
  if (!raw) return []
  if (Array.isArray(raw)) return raw
  if (typeof raw === "object") {
    return Object.entries(raw).map(([k, v]) => ({ ...v, key: v?.key || k }))
  }
  return []
}

const ValidationData = props => {
  const [showAddForm, setShowAddForm] = useState(false)
  const [editingVal, setEditingVal] = useState(null)
  const [editingIndex, setEditingIndex] = useState(null)

  const validations = props.validations || []
  const labelWidth = props.labelWidth ?? 3
  const dataWidth = 12 - labelWidth

  const addVal = () => {
    setEditingVal(null)
    setEditingIndex(null)
    setShowAddForm(true)
  }

  const togAddForm = () => setShowAddForm(prev => !prev)

  const onSave = val => {
    let next
    if (editingVal !== null) {
      next = [...validations]
      next[editingIndex] = val
    } else {
      next = [...validations, val]
    }
    props.setValidations(next)
    setEditingVal(null)
    setEditingIndex(null)
    togAddForm()
  }

  const editVal = (val, index) => {
    setEditingVal(val)
    setEditingIndex(index)
    setShowAddForm(true)
  }

  const removeVal = index => {
    props.setValidations(validations.filter((_, i) => i !== index))
  }

  return (
    <>
      <Modal isOpen={showAddForm} toggle={togAddForm} centered>
        <ValidationForm
          closeModal={togAddForm}
          onSave={onSave}
          valData={editingVal}
          vars={props.vars || []}
          isNew={editingVal === null}
        />
      </Modal>
      <Row className="mt-4">
        <Label className={`col-sm-${labelWidth} col-form-label`}>Validations</Label>
        <Col md={dataWidth}>
          {validations.length === 0 ? (
            <div className="text-muted">No validations added.</div>
          ) : (
            <Table>
              <Thead>
                <tr>
                  <th style={{ border: "none" }}>Type</th>
                  <th style={{ border: "none" }}>Variable</th>
                  <th style={{ border: "none" }}>Message</th>
                  <th style={{ border: "none" }}>Action</th>
                </tr>
              </Thead>
              <Tbody>
                {validations.map((val, index) => (
                  <tr key={val.key || index}>
                    <td style={{ border: "none" }}>{val.valdn_type}</td>
                    <td style={{ border: "none" }}>{val.var}</td>
                    <td style={{ border: "none" }}>{val.message}</td>
                    <td style={{ border: "none" }}>
                      <i
                        className="mdi mdi-pencil font-size-16 text-success me-1 pointer"
                        onClick={() => editVal(val, index)}
                      />{" "}
                      <i
                        className="mdi mdi-trash-can font-size-16 text-danger me-1 pointer"
                        onClick={() => removeVal(index)}
                      />
                    </td>
                  </tr>
                ))}
              </Tbody>
            </Table>
          )}
          <Button type="button" size="sm" color="primary" className="mt-1" onClick={addVal}>
            Add
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default ValidationData
